import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import LabeledSwitch from 'Components/UI/LabeledSwitch';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('enabled', {
    _component: () => LabeledSwitch,
  });
